import { Box, Typography } from "@mui/material";
import { brandingColors } from "../../utils";
import ProductTile from "../../product-tile";
import _ from "lodash";

export default function StepComponent({productList, stepTitle, amount, question, quizId}:any): JSX.Element {
  var array : number[] = [];
  
  if (productList.length >= amount) {
    array = _.range(0, amount);
  } else {
    array = _.range(0, productList.length);
  }
  
  return (
    <Box className="step"
      sx={{
        borderRadius: "10px",
      }}
    >
      <Typography className="category-title"
        variant={"subtitle2"}
        sx={{
          color: brandingColors["green-font"],
        }}
      >
        {stepTitle}
      </Typography>

      { productList.length === 0 ?
          '' : 
        (
          array.map((x, i) =>
            <ProductTile product={productList[i]} question={question} quizId={quizId} />
          )
        )}
    </Box>
  )
}